//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "FAS_Cr_Cys",
  data() {
    return {
      form: {
        sex: "0",
        age: "",
        height: "",
        scr: "",
        scys: "",
      },
      hasScore: false,
      disabled: false,
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let result = 0;
      for (const key in form) {
        console.log(form[key],'******');
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            if (form[key] == "---") {
              flag = false;
            } else {
              form[key] = Number(form[key]);
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false;
        return "--";
      } else {
        // 年龄40和40以下
        if (form.age <= 40) {
          if (form.age > 20 && form.sex == 1) {
            result = 107.3 / (form.scr / 0.9);
          } else if (form.age > 20 && form.sex != 1) {
            result = 107.3 / (form.scr / 0.7);
          } else if (form.age <= 20) {
            result = 107.3 / (form.scr / (0.04 * form.height));
          }
        } else {
          let qscr = form.sex == 1 ? 0.9 : 0.7;
          let qcys = form.age < 70 ? 0.82 : 0.95;
          result =
            (107.3 / (0.5 * (form.scr / qscr) + 0.5 * (form.scys / qcys))) *
            Math.pow(0.998, form.age - 40);
        }
        self.hasScore = true;
        return String(result.toFixed(2));
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/FAS_Cr_Cys.vue